export default __webpack_public_path__ + "static/media/Globe.a7c5d6aa.svg";